<div class="d-flex align-items-center justify-content-center min-vh-100 bg-light">
  <div class="text-center">
    <div class="card shadow border-0 p-4" style="max-width: 400px;">
      
      <!-- Spinner o ícono de error -->
      <div class="mb-4">
        <div *ngIf="!isError" class="spinner-border text-primary" style="width: 4rem; height: 4rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div *ngIf="isError" class="text-danger">
          <i class="fas fa-exclamation-triangle" style="font-size: 4rem;"></i>
        </div>
      </div>

      <!-- Mensaje -->
      <h5 [class.text-danger]="isError" [class.text-primary]="!isError">
        {{ message }}
      </h5>

      <!-- Mensaje adicional para errores -->
      <p *ngIf="isError" class="text-muted mt-3">
        Serás redirigido a la página de login en unos segundos...
      </p>

      <!-- Logo -->
      <div class="mt-4">
        <img src="/uncp-logo2.png" alt="UNCP Logo" class="img-fluid" style="max-height: 60px; opacity: 0.7;">
      </div>

    </div>
  </div>
</div>
